export default {
  data() {
    return {
      idModalRename: 'idPopupRename',
      isLoading: true,
      isLoadingMore: false,
      isFirstLoad: false,
      isUseInfinityScroll: false,
      isShowPopupRightClick: false,
      isShowModalDelete: false,
      isShowModalRename: false,
      isShowPopupDetail: false,
      dataTable: null,
      dataSelected: null,
      dataSelectedRename: null,
    };
  },

  methods: {
    handleSingleClick(data) {
      if (this.isShowPopupRightClick) this.closeRightClick();
      this.dataSelected = data;
      this.handleShowPopupDetail();
    },

    handleRightClick(data) {
      this.isShowPopupRightClick = true;
      this.dataSelected = data;

      document.addEventListener('contextmenu', (e) => {
        setTimeout(() => {
          const element = this.$refs.popupRightClick[0].$el;
          if (element) {
            element.style.top = `${e.clientY}px`;
            element.style.left = `${e.clientX}px`;
          }
        }, 150);
      });
    },

    closeRightClick() {
      this.isShowPopupRightClick = false;
      this.dataSelected = null;
    },

    openModalDelete() {
      this.isShowModalDelete = true;
      this.$refs.modalDelete.show();
      this.closeRightClick();
    },

    closeModalDelete() {
      this.isShowModalDelete = false;
      this.$refs.modalDelete.hide();
    },

    toggleModalRename(isOpen) {
      if (this.dataSelected) this.dataSelectedRename = this.dataSelected;

      if (isOpen) {
        if (this.isShowModalRename) {
          // Hide modal first if modal is opened
          const element = document.getElementById(this.idModalRename);
          if (element) element.classList.remove('show');
          setTimeout(() => {
            this.isShowModalRename = false;
          }, 200);

          // Open modal after modal is closed
          setTimeout(() => {
            this.toggleModalRename(true);
          }, 250);
        } else {
          this.isShowModalRename = true;

          setTimeout(() => {
            const element = document.getElementById(this.idModalRename);
            if (element) element.classList.add('show');
          }, 200);
        }
      } else {
        const element = document.getElementById(this.idModalRename);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isShowModalRename = false;
          this.dataSelectedRename = null;
        }, 200);
      }
    },

    handleShowPopupDetail() {
      this.isShowPopupDetail = true;

      setTimeout(() => {
        const element = document.getElementById('popupDetail');
        if (element) element.classList.add('show');
      }, 200);
    },

    handleClosePopupDetail() {
      const element = document.getElementById('popupDetail');
      if (element) element.classList.remove('show');

      setTimeout(() => {
        this.isShowPopupDetail = false;
      }, 250);
    },

    onClickOutside() {
      if (this.isShowPopupRightClick) this.closeRightClick();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/jMixDataList.js